import React, { useEffect, useRef, useState } from 'react';
import { Paper, Popper, MenuList, MenuItem } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import {
  StyledSelectTrigger,
  MENU_PAPER_SX,
  MENU_ITEM_SX,
} from './index.style';

// Cùng khuôn với FontFamilySelect thay vì Select dùng chung: menu của Select
// chung mang sẵn quy tắc hover và focus riêng, đè bằng sx là đấu specificity.
const SelectField = ({ width, value, options, onChange }) => {
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const [open, setOpen] = useState(false);

  // Popper không có lớp phủ nên phải tự đóng khi bấm ra ngoài.
  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = ({ target }) => {
      if (
        triggerRef.current?.contains(target) ||
        menuRef.current?.contains(target)
      )
        return;
      setOpen(false);
    };
    document.addEventListener('mousedown', onPointerDown);
    return () => document.removeEventListener('mousedown', onPointerDown);
  }, [open]);

  const selected = options.find((option) => option.value === value);

  const pick = (next) => {
    setOpen(false);
    if (next !== value) onChange(next);
  };

  return (
    <>
      <StyledSelectTrigger
        ref={triggerRef}
        $width={width}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="label">{selected?.label}</span>
        <KeyboardArrowDownRoundedIcon className="arrow" />
      </StyledSelectTrigger>

      <Popper
        open={open}
        anchorEl={triggerRef.current}
        placement="bottom-start"
        style={{ zIndex: 1400, width: width || undefined }}
      >
        <Paper ref={menuRef} sx={MENU_PAPER_SX}>
          <MenuList dense disablePadding>
            {options.map((option) => (
              <MenuItem
                key={option.value}
                selected={option.value === value}
                onClick={() => pick(option.value)}
                sx={MENU_ITEM_SX}
              >
                {option.label}
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      </Popper>
    </>
  );
};

export default SelectField;
